import React from 'react';

import { useFelaEnhanced } from '@ackee/fela';
import { BlogPostDetail, PostTag } from '../../types';

import { TagsList } from '../TagsList';
import { ShareContainer } from './ShareContainer/ShareContainer';

import * as felaRules from './MetadataContainer.rules';

export interface MetadataContainerProps {
    tags?: PostTag[];
    title: BlogPostDetail['title'];
}

export const MetadataContainer = ({ tags, title }: MetadataContainerProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <div className={styles.container}>
            {tags && <TagsList tags={tags} />}
            <ShareContainer title={title} />
        </div>
    );
};
